export enum BulkAction {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
}
